import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {  ISystemDialogActionPayload, ISystemState } from './types'
import {v4 as uuidv4} from 'uuid'


const initialState: ISystemState = {
  dialogs: [],
  uploads: []
}

export const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    systemAddDialog(state, action: PayloadAction<ISystemDialogActionPayload>) {
      if(action.payload.actions.length === 0) {
        action.payload.actions.push({
          color: 'primary',
          text: 'OK',
          action: () => {}
        })
      }
      state.dialogs.push({
        ...action.payload,
        priority: 0,
        id:uuidv4()
      });
    },
    systemRemoveDialog(state, action: PayloadAction<string>) {
      state.dialogs = state.dialogs.filter(dialog => dialog.id !== action.payload);
    },

    systemMenuToggle(state, action: PayloadAction<boolean>) {
      state.menuOpen = action.payload;
    }
  }
})

// Action creators are generated for each case reducer function
export const {
  systemAddDialog,
  systemRemoveDialog,
  systemMenuToggle
} = systemSlice.actions

export default systemSlice.reducer